import { IGeneralSection } from 'interfaces/IMarketing';
import Section from 'containers/Learn/Articles/Section/Section';
import { HEADER_SIZE } from './utils/getHeader.util';
import styles from './styles.module.scss';

interface ILayoutC {
  articles: IGeneralSection[];
  onDownloadClick: (label: string) => void;
  visibleItemsCount?: number;
  highestHeadingSize?: HEADER_SIZE;
}

const LayoutC = ({
  articles,
  onDownloadClick,
  visibleItemsCount,
  highestHeadingSize = HEADER_SIZE.H1,
}: ILayoutC) => (
  <section className={styles.layoutC}>
    {articles.slice(0, visibleItemsCount).map((article, index) => (
      <Section
        key={article.id}
        article={article}
        needMarginRight={!(articles && index === articles.length - 1)}
        onDownloadClick={onDownloadClick}
        highestHeadingSize={highestHeadingSize}
      />
    ))}
  </section>
);

export default LayoutC;
